import React from 'react'
import { InView } from 'react-intersection-observer'
import { Updater, Widget, fromJSX } from 'widgets-for-react'
import { CookieSensitiveContentWrapper } from '../../../../cms/blocks/cookiebar.mod'
import { setCookie } from '../../../../cms/blocks/cookiebar.utils.mod'
import { getClassName } from '../../../../cms/blocks/utils.gen'
import { blockInviewHandler } from '../../../../drupal/rendering/inview_utils.mod'
import { CMSState } from '../../../drupalPage/state'

export type HubspotIFrameProps = {
  index: number
  useCookieBar: boolean
  cookiePlaceholder?: JSX.Element | string
  cookieButton?: string
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
  inputfields: inputfields
}

export type inputfields = {
  portalID: string
  formID: string
}

export type HubSpotFrameBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  iframe_classname: string
}>

declare const hbspt: any

const script = (portalID: string, formID: string) =>
  hbspt.forms.create({
    portalId: portalID,
    formId: formID,
    target: '#hubspotiframe'
  })

export function hubspotIFrameBlock(
  props: HubspotIFrameProps,
  options?: { style?: HubSpotFrameBlockStyle; key?: string }
): Widget<Updater<CMSState>> {
  return fromJSX((onDone) => (
    <InView
      as="section"
      onChange={(inView) =>
        blockInviewHandler(
          'hubspotIframe',
          inView,
          `io-${options && options.key ? options.key : props.index}`,
          getClassName(options, 'inview_classname', 'inview')
        )
      }
      triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
      threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
      id={`io-${options && options.key ? options.key : props.index}`}
      className={getClassName(options, 'block_classname', 'container')}
      key={options && options.key ? options.key : `block-${props.index}`}
    >
      <div className={getClassName(options, 'inner_classname', 'py-5')}>
        <div className={getClassName(options, 'content_classname', '')}>
          <div className={getClassName(options, 'iframe_classname', '')}>
            {props.useCookieBar ? (
              <CookieSensitiveContentWrapper
                groupId={4}
                placeholder={
                  <div className="media__placeholder">
                    <div className="media__inner">
                      <p>{props.cookiePlaceholder}</p>
                      <a
                        className=""
                        onClick={() => {
                          setCookie('so_you_accepted_the_cookies?', 'yes_i_did', 100000)
                          window.location.reload()
                        }}
                      >
                        {props.cookieButton}
                      </a>
                    </div>
                  </div>
                }
              >
                <HubspotIFrame portalID={props.inputfields.portalID} formID={props.inputfields.formID}></HubspotIFrame>
              </CookieSensitiveContentWrapper>
            ) : (
              <HubspotIFrame portalID={props.inputfields.portalID} formID={props.inputfields.formID}></HubspotIFrame>
            )}
          </div>
        </div>
      </div>
    </InView>
  ))
}

export class HubspotIFrame extends React.Component<inputfields, {}> {
  componentDidMount() {
    script(this.props.portalID, this.props.formID)
  }

  render() {
    return <div id="hubspotiframe" className="block__inner container container--m"></div>
  }
}
